import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    needToShowSets: true,
    hasDelayedEvents: true
  },
  modules: {
    info: [
      'timer',
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away,
          customClass: ingameData => {
            const { playersCount: { home, away } } = ingameData

            if (Number(home) !== 7 || Number(away) !== 7) return 'football-players-count-changed'

            return ''
          }
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score
    },
    fieldScheme: {
      component: 'football-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    playersCount: {
      home: 7,
      away: 7
    },
    hasTimer: true,
    shootoutsLog: {
      home: [],
      away: []
    },
    isReversedField: false,
    getOvertimePeriodName: 'ET',
    shootoutPeriodName: 'P'
  }
}
